/* Set gift (David, 2026-10-17): the first 10 orders with a top (a tank, the halter or a jacket) and a pair of
   leggings get a headscarf or headband free. The gift is its own C$0 product, "Free gift with your set"
   (handle set-gift), whose stock is the number of gifts left (7 after the first 3 orders), so Shopify counts
   them down with every order and the bag and product pages can say how many are left. Once the bag holds a top
   and leggings this adds it with a "Gift" property naming the piece (the one in the leggings' colour, which the
   shopper can swap), so the order tells Amanda what to pack; it comes back out when the set breaks up, one a
   shopper removes stays out until the bag changes, and once Shopify says none are left it isn't offered
   again that visit. Being free, it needs no discount code, so WELCOME10 works as usual on everything else.
   Runs after theme.js (window.Vesari.cart.refresh redraws the bag; theme.js fires vesari:cart whenever the
   bag has been redrawn). The gift line markup is snippets/gift-line.liquid; snippets/gift-nudge.liquid and
   gift-pdp.liquid tell the offer; this file also runs the bag's discount code box (snippets/bag-codes.liquid).
   Loaded from sections/cart-drawer.liquid. */
(() => {
  const V = window.Vesari;
  if (!V || !V.routes || !V.cart) return;
  const GIFT_VARIANT = 67807858655445;
  const TOPS = ['organic-cotton-two-tone-halter', 'organic-cotton-sweetheart-tank', 'organic-cotton-two-tone-tank', 'organic-cotton-zip-up-jacket', 'organic-cotton-zip-up-jacket-tiramisu'];
  // leggings -> the piece in its colour (the headscarf for navy, as there's no navy headband)
  const CHOICE_FOR = {
    'organic-cotton-straight-leg-leggings': 'Headscarf (Navy)',
    'organic-cotton-straight-leg-leggings-tiramisu': 'Headband (Tiramisu)',
    'organic-cotton-straight-leg-leggings-amaro-cherry': 'Headband (Amaro Cherry)',
  };
  const OLD_CODE = 'SETGIFT'; // the first version's code; carts that still carry it are cleaned up
  const OFF = 'vesari:gift:off';
  const DECLINED = 'vesari:gift:declined';
  const flag = (key, on) => {
    try {
      if (!on) return sessionStorage.getItem(key) === '1';
      sessionStorage.setItem(key, '1');
    } catch {}
    return false;
  };
  // A shopper who removes the gift is saying no to it for this bag: the bag (its pieces, as sorted variant
  // ids) is remembered, and the gift is offered again as soon as the bag changes (a piece out and back in,
  // or anything added).
  const bagSig = (ids) => ids.map(Number).sort((a, b) => a - b).join(',');
  const declinedFor = () => {
    try {
      return sessionStorage.getItem(DECLINED);
    } catch {
      return null;
    }
  };
  const decline = (sig) => {
    try {
      if (sig == null) sessionStorage.removeItem(DECLINED);
      else sessionStorage.setItem(DECLINED, sig);
    } catch {}
  };
  let addFails = 0;
  const left = Number(document.querySelector('script[data-gift-left]')?.dataset.giftLeft || 0);
  const soldOut = !(left > 0);
  const ADD = V.routes.cart_add;
  const CHANGE = V.routes.cart_change;
  const UPDATE = `${V.routes.cart}/update`;
  const getCart = () => fetch(`${V.routes.cart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const post = (route, body) =>
    fetch(`${route}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then((r) => r.ok)
      .catch(() => false);
  const isGift = (item) => item.variant_id === GIFT_VARIANT;
  const isOldGift = (item) => !isGift(item) && Boolean(item.properties && item.properties._gift);
  const codesOf = (cart) => (cart.discount_codes || []).map((d) => d.code).filter(Boolean);
  const zero = (lines) => Object.fromEntries(lines.map((l) => [l.key, 0]));

  let busy = false;
  let again = false;
  async function sync(swapTo) {
    if (busy) {
      again = true;
      return;
    }
    busy = true;
    let changed = false;
    try {
      let cart = await getCart();
      // The first version gave the real headscarf/headband with a code; take those lines and the code out.
      const old = (cart.items || []).filter(isOldGift);
      const codes = codesOf(cart);
      if (old.length || codes.some((c) => c.toUpperCase() === OLD_CODE)) {
        const body = { discount: codes.filter((c) => c.toUpperCase() !== OLD_CODE).join(',') };
        if (old.length) body.updates = zero(old);
        await post(UPDATE, body);
        changed = true;
        cart = await getCart();
      }
      const items = cart.items || [];
      const gifts = items.filter(isGift);
      const rest = items.filter((i) => !isGift(i));
      const top = rest.some((i) => TOPS.includes(i.handle));
      const legs = rest.find((i) => CHOICE_FOR[i.handle]);
      const sig = bagSig(rest.map((i) => i.variant_id));
      const no = declinedFor();
      if (no !== null && no !== sig) decline(null);
      if (!(top && legs) || soldOut || flag(OFF) || declinedFor() === sig) {
        if (gifts.length) changed = (await post(UPDATE, { updates: zero(gifts) })) || changed;
        return;
      }
      const choice = swapTo || (gifts[0] && gifts[0].properties && gifts[0].properties.Gift) || CHOICE_FOR[legs.handle];
      const good = gifts.length === 1 && gifts[0].quantity === 1 && gifts[0].properties && gifts[0].properties.Gift === choice;
      if (good) return;
      if (gifts.length) await post(UPDATE, { updates: zero(gifts) });
      changed = true;
      // Shopify refusing it as unavailable (422: none left) ends the offer for the visit; any other failure
      // is tried again on the next bag change, at most twice a page, so nothing can loop.
      const res = await fetch(`${ADD}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: GIFT_VARIANT, quantity: 1, properties: { Gift: choice } }] }),
      }).catch(() => null);
      if (!res || !res.ok) {
        if (res && res.status === 422) flag(OFF, true);
        else if (++addFails > 2) flag(OFF, true);
      }
    } catch {
      // the bag stays as it was; the next bag change tries again
    } finally {
      busy = false;
      if (changed) await V.cart.refresh();
      if (again) {
        again = false;
        sync();
      }
    }
  }

  // Swapping the piece: the line shows the new one at once (photo, name, colour, outline), then one
  // /cart/change.js call sets the line's Gift property and brings the redrawn bag back with it. Taps made
  // while one is on its way only keep the last choice, which is applied once the first has landed.
  const sectionIds = () => {
    const ids = [];
    if (document.querySelector('[data-cart-drawer]')) ids.push('cart-drawer');
    const main = document.querySelector('[data-main-cart]')?.dataset.sectionId;
    if (main) ids.push(main);
    return ids.join(',');
  };
  // A line taken out (Remove, or - down to 0) fades and folds away at once, in the drawer and on /cart;
  // the redrawn bag then drops it for good (or brings it back if Shopify refused).
  const collapse = (key) =>
    document.querySelectorAll(`[data-key="${CSS.escape(key)}"]`).forEach((li) => {
      if (li.dataset.leaving) return;
      li.dataset.leaving = '1';
      li.style.overflow = 'hidden';
      li.style.height = `${li.offsetHeight}px`;
      li.style.pointerEvents = 'none';
      li.style.transition = 'opacity 160ms ease, height 260ms cubic-bezier(0.22,1,0.36,1), padding 260ms cubic-bezier(0.22,1,0.36,1), border-color 260ms ease';
      requestAnimationFrame(() => {
        li.style.opacity = '0';
        li.style.height = '0px';
        li.style.paddingTop = '0px';
        li.style.paddingBottom = '0px';
        li.style.borderBottomColor = 'transparent';
      });
    });
  // The swapped line comes back from Shopify under a new key, so theme.js would replay its price fade;
  // while a swap lands, the gift line's prices are shown as they are (set on vesari:cart, before paint).
  let quiet = false;
  let swapping = false;
  let nextChoice = null;
  async function swapGift(pick) {
    const choice = pick.dataset.giftChoice;
    document.querySelectorAll('[data-gift-line]').forEach((line) => {
      line.querySelectorAll('[data-gift-choice]').forEach((b) => {
        const on = b.dataset.giftChoice === choice;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('border-ink', on);
        b.classList.toggle('border-transparent', !on);
      });
      // each line's own swatch carries the photo at that line's size (drawer 264, /cart 288)
      const own = line.querySelector(`[data-gift-choice="${CSS.escape(choice)}"]`) || pick;
      const photo = line.querySelector('a img, div > img');
      if (photo && own.dataset.giftPhoto) photo.src = own.dataset.giftPhoto;
      const name = line.querySelector('a.label');
      if (name && own.dataset.giftName) name.textContent = own.dataset.giftName;
      const colour = line.querySelector('[data-gift-colour]');
      if (colour) colour.textContent = own.dataset.giftColourName || '';
    });
    if (swapping || busy) {
      nextChoice = choice;
      return;
    }
    swapping = true;
    quiet = true;
    try {
      const key = document.querySelector('[data-gift-line]')?.dataset.key;
      const res = await fetch(`${CHANGE}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 1, properties: { Gift: choice }, sections: sectionIds(), sections_url: location.pathname }),
      });
      const json = res.ok ? await res.json().catch(() => ({})) : {};
      await V.cart.refresh(json.sections || undefined);
    } catch {
      await V.cart.refresh();
    } finally {
      swapping = false;
      quiet = false;
      if (nextChoice && nextChoice !== choice) {
        const later = nextChoice;
        nextChoice = null;
        sync(later);
      }
      nextChoice = null;
    }
  }

  // Once the offer is over for this visit, the "free headscarf or headband" notes go away too.
  const hideNudges = () => flag(OFF) && document.querySelectorAll('[data-gift-nudge]').forEach((n) => n.remove());

  // The bag's discount code box (snippets/bag-codes.liquid): WELCOME10 and the like apply here, next to the gift.
  const say = (text) =>
    document.querySelectorAll('[data-code-msg]').forEach((m) => {
      m.textContent = text;
      m.classList.toggle('hidden', !text);
      if (text) m.closest('details')?.setAttribute('open', '');
    });
  async function applyCode(code) {
    const cart = await getCart();
    const others = codesOf(cart).filter((c) => c.toUpperCase() !== code);
    await post(UPDATE, { discount: [...others, code].join(',') });
    const after = await getCart();
    const entry = (after.discount_codes || []).find((d) => (d.code || '').toUpperCase() === code);
    const ok = Boolean(entry && entry.applicable);
    if (!ok) await post(UPDATE, { discount: codesOf(after).filter((c) => c.toUpperCase() !== code).join(',') });
    await V.cart.refresh();
    say(ok ? `${code} applied.` : `${code} can’t be used with this bag.`);
    return ok;
  }
  document.addEventListener('submit', async (e) => {
    const form = e.target instanceof Element ? e.target.closest('[data-code-form]') : null;
    if (!form) return;
    e.preventDefault();
    const input = form.querySelector('[data-code-input]');
    const button = form.querySelector('[data-code-apply]');
    const code = ((input && input.value) || '').trim().toUpperCase();
    if (!code) {
      say('Enter a code first.');
      return;
    }
    if (button) button.disabled = true;
    try {
      await applyCode(code);
    } catch {
      say('That didn’t go through. Please try again.');
    } finally {
      document.querySelectorAll('[data-code-apply]').forEach((b) => (b.disabled = false));
    }
  });

  addEventListener('vesari:cart', () => {
    if (quiet) document.querySelectorAll('[data-gift-line] [class*="animate-[price-in"]').forEach((el) => (el.style.animation = 'none'));
    hideNudges();
    sync();
  });
  document.addEventListener(
    'click',
    (e) => {
      if (!(e.target instanceof Element)) return;
      // Removing the gift line is a no thanks for this visit; a swap button changes the piece.
      if (e.target.closest('[data-line-remove]')?.closest('[data-gift-line]')) {
        const root = e.target.closest('[data-cart-panel], [data-main-cart]') || document;
        decline(bagSig([...root.querySelectorAll('li[data-key][data-variant-id]')].filter((l) => !l.hasAttribute('data-gift-line') && !l.dataset.leaving).map((l) => l.dataset.variantId)));
      }
      // Taking out the top or leggings that makes the set: the piece and the gift both go, in one call,
      // so the bag redraws once (theme.js's own handler, which would remove only the piece, is skipped).
      const out = e.target.closest('[data-line-remove], [data-line-minus]');
      const line = out?.closest('[data-key]');
      const giftLine = document.querySelector('[data-gift-line]');
      if (line && giftLine && !line.hasAttribute('data-gift-line')) {
        const qty = Number(line.querySelector('[data-line-qty-text]')?.textContent || line.dataset.qty) || 0;
        if (out.hasAttribute('data-line-remove') || qty <= 1) {
          const root = line.closest('[data-cart-panel], [data-main-cart]') || document;
          const left = [...root.querySelectorAll('li[data-key][data-handle]')].filter((l) => l.dataset.key !== line.dataset.key && !l.hasAttribute('data-gift-line') && !l.dataset.leaving).map((l) => l.dataset.handle);
          if (!(left.some((h) => TOPS.includes(h)) && left.some((h) => CHOICE_FOR[h]))) {
            e.preventDefault();
            e.stopImmediatePropagation();
            const keys = [line.dataset.key, giftLine.dataset.key];
            keys.forEach(collapse);
            fetch(`${UPDATE}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates: Object.fromEntries(keys.map((k) => [k, 0])), sections: sectionIds(), sections_url: location.pathname }),
            })
              .then((r) => (r.ok ? r.json() : {}))
              .then((json) => V.cart.refresh(json.sections || undefined))
              .catch(() => V.cart.refresh());
            return;
          }
        }
      }
      // Any other line going to 0 fades out now; theme.js's handler then makes the change.
      if (line) {
        const qty = Number(line.querySelector('[data-line-qty-text]')?.textContent || line.dataset.qty) || 0;
        if (out.hasAttribute('data-line-remove') || qty <= 1) collapse(line.dataset.key);
      }
      const pick = e.target.closest('[data-gift-choice]');
      if (pick) {
        e.preventDefault();
        if (pick.getAttribute('aria-pressed') !== 'true') swapGift(pick);
      }
      const drop = e.target.closest('[data-code-remove]');
      if (drop) {
        e.preventDefault();
        const code = drop.dataset.codeRemove.toUpperCase();
        getCart()
          .then((cart) => post(UPDATE, { discount: codesOf(cart).filter((c) => c.toUpperCase() !== code).join(',') }))
          .then(() => V.cart.refresh())
          .then(() => say(''))
          .catch(() => {});
      }
    },
    true,
  );
  hideNudges();
  if (document.querySelector('[data-cart-drawer], [data-main-cart]')) sync();
})();
